import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_82: FaireProductEntity = {
  token: "legacy_prod_abbott-82",
  type: "product",
  name: "Large Peaceful Garden Napkins, 20 Pack",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e37ae539b0e01fe14b4f6f041e605151ea63101e01f96ab4485122e81f312ec3.jpeg",
  priceDollars: 12,
  subcategory: "Tableware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_party-supplies"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
